import { useReveal } from "../../../../hooks/useReveal";
import styles from "./Testimonials.module.css";

const testimonials = [
  {
    feat: true,
    quote:
      '"It was a seamless process working with the Awasource team and I really like how easy it was for me to find the best talents through them"',
    initials: "OA",
    av: "av1",
    name: "Oluwafisayomi Adekanmbi",
    role: "HR Executive",
  },
  {
    quote:
      '"The Awasource system of connecting talent with a client has proven instrumental in helping me get a QA job. Great team work producing results"',
    initials: "IN",
    av: "av3",
    name: "Ifechukwude Nwoko",
    role: "QA Engineer · Kima",
  },
  {
    quote:
      '"The Awasource system of connecting talent with a client was key in helping me get my current UI/UX Design job. I\'m really excited about this. Great job guys."',
    initials: "IA",
    av: "av4",
    name: "Ibukunoluwa Adura",
    role: "UI/UX Design",
  },
];

function TestimonialCard({ feat, quote, initials, av, name, role }) {
  const { ref, isVisible } = useReveal();
  return (
    <div
      ref={ref}
      className={`${styles.card} ${feat ? styles.feat : ""} ${isVisible ? styles.visible : styles.hidden}`}
    >
      <div className={styles.stars}>★ ★ ★ ★ ★</div>
      <p className={styles.quote}>{quote}</p>
      <div className={styles.author}>
        <div className={`${styles.avatar} ${styles[av]}`}>{initials}</div>
        <div className={styles.authorInfo}>
          <div className={styles.authorName}>{name}</div>
          <div className={styles.authorRole}>{role}</div>
        </div>
      </div>
    </div>
  );
}

export default function Testimonials() {
  return (
    <section className={styles.section} id="testimonials">
      <div className={styles.container}>
        <div className={styles.sectionHead}>
          <span className={styles.eyebrow}>Loved by hiring teams</span>
          <h2 className={styles.h2}>Don't take our word for it.</h2>
          <p className={styles.sub}>
            Real results from teams that switched to Awasource.
          </p>
        </div>

        <div className={styles.grid}>
          {testimonials.map((t) => (
            <TestimonialCard key={t.name} {...t} />
          ))}
        </div>
      </div>
    </section>
  );
}
